module.exports = __webpack_public_path__ + "static/media/icon-equipe-blue.cc154482.svg";